module.exports = __webpack_public_path__ + "static/media/background.0c1ffb19.jpg";